import { lang } from '@umu/ukit-lang';
import { IOperateItem, QuestionOperateType, QuestionType } from '../../../interface/multiCapabilityTemplate';
import { IQuestionTypeInfo } from '../interface';
import React from 'react';
import { Iconfont, Tooltip } from '@umu/umu-design';
const questionBasicOptionList = [
    {
        key: '1',
        label: lang('必填'),
    },
    {
        key: '0',
        label: lang('选填'),
    },
];
const questionBasicOtherList = [
    {
        key: '1',
        label: lang('必须输入文字'),
    },
    {
        key: '0',
        label: lang('可不输入文字'),
    },
];
const defaultWhiteOverlayInnerStyle = {
    background: '#ffffff',
    color: '#222222',
    fontSize: '0.14rem',
    lineHeight: '0.2rem',
    padding: '0.12rem',
};

const tips = (
    <div className="question-radio-tooltip">
        <p className="label-title">{lang('适用于设置满意度、认同度等类型的问题。')}</p>
        <p className="label-desc">
            {lang(
                '讲师可以设置从 0 到 10 之间的任意范围作为选项的选择范围，并可以对最大值、最小值赋予标签，说明数值含义。如数值 1 表示“不满意”，数值 5 表示“非常满意”。',
            )}
        </p>
    </div>
);
const numberRadioTitle = (
    <div className="template-question-tooltip">
        <span>{lang('数值型')}</span>
        <Tooltip title={tips} placement="bottom" hideArrow overlayInnerStyle={defaultWhiteOverlayInnerStyle}>
            <Iconfont type="tips" className="tooltip-icon-tips" />
        </Tooltip>
    </div>
);
const hideRadioList = [QuestionType.PARAGRAPH];
const questionTypeMap: Record<QuestionType, IQuestionTypeInfo> = {
    [QuestionType.RADIO]: {
        title: lang('单选题'),
    },
    [QuestionType.CHECKBOX3]: {
        title: lang('多选题'),
    },
    [QuestionType.TEXT]: {
        title: lang('开放式'),
    },
    [QuestionType.NUMBER5]: {
        title: numberRadioTitle,
    },
    [QuestionType.PARAGRAPH]: {
        title: lang('段落说明'),
    },
};
const optionExternalList: IOperateItem[] = [
    {
        key: QuestionOperateType.OPTION_ADD,
        label: '',
        className: 'btn-width-auto',
        type: 'ghost-grey',
        iconName: 'AddSmall',
    },
    {
        key: QuestionOperateType.OPTION_DELETE,
        type: 'ghost-grey',
        label: '',
        className: 'btn-width-auto',
        iconName: 'Line',
    },
];
const showRadioList: QuestionType[] = [
    QuestionType.RADIO,
    QuestionType.CHECKBOX3,
    QuestionType.TEXT,
    QuestionType.NUMBER5,
];
const questionTypeList: any[] = showRadioList.map((item) => {
    const { title } = questionTypeMap[item];
    return {
        label: title,
        key: item,
    };
});
const getScoreList = (length: number, startIndex = 1) => {
    const list = [];
    for (let i = startIndex; i <= length; i++) {
        list.push({
            value: String(i),
            label: String(i),
        });
    }
    return list;
};
export {
    getScoreList,
    hideRadioList,
    optionExternalList,
    questionBasicOptionList,
    questionBasicOtherList,
    showRadioList,
    questionTypeList,
    defaultWhiteOverlayInnerStyle,
};
